import RootState from '@vue-storefront/core/types/RootState'
import MyAccountState from '../types/MyAccountState'
import { GetterTree } from 'vuex'

export const getters: GetterTree<MyAccountState, RootState> = {
  getCurrentPage: state => state.current,
  getPerPage: state => state.perPage
}
